export default "__VITE_ASSET__DdjoengV__"